define(["require", "exports", "jquery", "knockout", "../../utils/dateUtils", "../../utils/kendoUtils", "../../models/UserContext", "../../models/BillItemModel"], function (require, exports, $, ko, DateUtils, KendoUtils, UserContext, BillItemModel) {
    "use strict";
    var CustomerCdrs = /** @class */ (function () {
        function CustomerCdrs(customerId, lookupLists, initGridCallback) {
            this.canViewCdr = ko.observable(UserContext.hasAccess("Admin,CallDetailRecord.View"));
            this.canExportCdr = ko.observable(UserContext.hasAccess("Admin,CallDetailRecord.Export"));
            this.filterCdrByStartDate = ko.observable(DateUtils.firstDayOfMonth());
            this.filterCdrByEndDate = ko.observable(DateUtils.lastDayOfMonth());
            this.filterCdrByAny = ko.observable("");
            this.filterCdrByProvider = ko.observable("");
            this.filterCdrByCallType = ko.observable("");
            this.editModel = ko.observable(new BillItemModel());
            this.customerId = ko.observable(0);
            this.btn = ko.observable();
            var self = this;
            self.customerId(customerId);
            self.lookupLists = lookupLists;
            self.customerCdrGridStructure = self.lookupLists.GridStructures.CallDetailRecordStructure;
            if (this.canViewCdr()) {
                self.initExportDataSource();
                if (initGridCallback) {
                    initGridCallback(self);
                }
            }
        }
        CustomerCdrs.prototype.initGrid = function () {
            if (this.canViewCdr()) {
                this.initCdrDetailsSummary();
                this.initCdrMenu();
                ko.applyBindings(this, document.getElementById("divCdrSummaryTable"));
            }
        };
        CustomerCdrs.prototype.initExportDataSource = function () {
            var self = this;
            self.customerCdrDataSourceOptions = {
                transport: {
                    read: {
                        url: "/CustomerCdrs/GetCdrDetailRecords",
                        type: "POST",
                        data: function () {
                            var data = {};
                            data.customerId = self.customerId();
                            data.startDate = DateUtils.toIsoStringDate(self.filterCdrByStartDate());
                            data.endDate = DateUtils.toIsoStringDate(self.filterCdrByEndDate());
                            if (self.filterCdrByAny()) {
                                data.filterText = self.filterCdrByAny();
                            }
                            if (self.filterCdrByProvider()) {
                                data.provider = self.filterCdrByProvider();
                            }
                            if (self.filterCdrByCallType()) {
                                data.callType = self.filterCdrByCallType();
                            }
                            return data;
                        },
                        dataType: "json"
                    }
                },
                sort: {
                    field: "DateTimeRange",
                    dir: "desc"
                },
                schema: {
                    model: self.customerCdrGridStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            };
            self.customerCdrDataSource = new kendo.data.DataSource(self.customerCdrDataSourceOptions);
        };
        CustomerCdrs.prototype.initCdrDetailsSummary = function () {
            var self = this;
            var columns = self.customerCdrGridStructure.columns;
            self.customerCdrTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerCdrs/GetCdrDetailRecords",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.customerId = self.customerId();
                                data.startDate = DateUtils.toIsoStringDate(self.filterCdrByStartDate());
                                data.endDate = DateUtils.toIsoStringDate(self.filterCdrByEndDate());
                                if (self.filterCdrByAny()) {
                                    data.filterText = self.filterCdrByAny();
                                }
                                if (self.filterCdrByProvider()) {
                                    data.provider = self.filterCdrByProvider();
                                }
                                if (self.filterCdrByCallType()) {
                                    data.callType = self.filterCdrByCallType();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    sort: {
                        field: "DateTimeRange",
                        dir: "desc"
                    },
                    schema: {
                        model: self.customerCdrGridStructure.model
                    },
                    pageSize: 10,
                    aggregate: self.customerCdrGridStructure.aggregate,
                    serverAggregates: true
                },
                gridOptions: {
                    toolbar: kendo.template($("#cdr-summary-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    scrollable: true,
                    height: 500,
                },
                enableExport: {
                    entityName: "CallDetailRecord",
                    title: "Call Summary Records",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                gridId: "divCdrSummaryTable",
                showPagerOnTop: false
            };
            self.customerCdrTable.initGrid(gridOptions);
            self.initCdrTableFilter();
        };
        CustomerCdrs.prototype.initCdrTableFilter = function () {
            var self = this;
            self.filterCdrByStartDate.subscribe(function () {
                self.customerCdrTable.getGridData().dataSource.read();
            });
            self.filterCdrByEndDate.subscribe(function () {
                self.customerCdrTable.getGridData().dataSource.read();
            });
            self.filterCdrByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.customerCdrTable.getGridData().dataSource.read();
            });
            self.filterCdrByCallType.subscribe(function () {
                self.customerCdrTable.getGridData().dataSource.read();
            });
            self.filterCdrByProvider.subscribe(function () {
                self.customerCdrTable.getGridData().dataSource.read();
            });
        };
        CustomerCdrs.prototype.initCdrMenu = function () {
            var self = this;
            setTimeout(function () {
                var element = document.getElementById("divCdrSummaryTable");
                $("#menu", element).kendoMenu();
                // get a reference to the menu widget
                var menu = $("#menu", element).data("kendoMenu");
                // bind to the select event
                menu.bind("select", function (e) {
                    // handle event
                    var actionName = $(e.item).data("action");
                    if (actionName) {
                        self[actionName]();
                    }
                });
            });
        };
        CustomerCdrs.prototype.clearCdrFilter = function () {
            var self = this;
            self.filterCdrByStartDate(DateUtils.firstDayOfMonth());
            self.filterCdrByEndDate(DateUtils.lastDayOfMonth());
            self.filterCdrByAny(null);
            self.filterCdrByCallType(null);
            self.filterCdrByProvider(null);
        };
        CustomerCdrs.prototype.exportToCdr = function () {
            var self = this;
            if (self.canExportCdr) {
                self.customerCdrTable.exportTo();
            }
        };
        return CustomerCdrs;
    }());
    return CustomerCdrs;
});
//# sourceMappingURL=customerCdrs.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerCdrs.js
// module id = 200
// module chunks = 2